import { render } from "./ProgramsTab.vue?vue&type=template&id=eea491ea"
import script from "./ProgramsTab.vue?vue&type=script&lang=js"
export * from "./ProgramsTab.vue?vue&type=script&lang=js"
script.render = render

export default script